import {Directive, ElementRef, Input, OnDestroy, OnInit} from '@angular/core';
import {ShContextMenuService} from './sh-context-menu.service';
import {ShContextMenuComponent} from './sh-context-menu.component';
import {Subscription} from 'rxjs';
import {fromEvent} from 'rxjs';
import {merge} from 'rxjs';
export class ShAttachMenuDirective implements OnDestroy, OnInit {
   menu: ShContextMenuComponent;
   triggers: string[];
   data: any;
  sub: Subscription;
/**
 * @param {?} ctxService
 * @param {?} elm
 */
constructor(private ctxService: ShContextMenuService,
private elm: ElementRef) {
  }
/**
 * @return {?}
 */
ngOnInit(): void {
    this.setupEvents();
  }
/**
 * @return {?}
 */
private setupEvents() {
    const /** @type {?} */ observables = [];

    if (!this.triggers) {
      observables.push(fromEvent(this.elm.nativeElement, 'contextmenu'));
    } else {
      this.triggers.forEach((t) => {
        observables.push(fromEvent(this.elm.nativeElement, t));
      });
    }

    this.sub = merge(...observables).subscribe(this.openMenu.bind(this));
  }
/**
 * @param {?} event
 * @return {?}
 */
openMenu(event: MouseEvent) {
    this.ctxService.openMenu({
      menu: this.menu,
      mouseEvent: event,
      targetElement: this.elm,
      data: this.data
    });
  }
/**
 * @return {?}
 */
ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[shAttachMenu]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ShContextMenuService, },
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'menu': [{ type: Input, args: ['shAttachMenu', ] },],
'triggers': [{ type: Input, args: ['shMenuTriggers', ] },],
'data': [{ type: Input, args: ['shMenuData', ] },],
};
}

function ShAttachMenuDirective_tsickle_Closure_declarations() {
/** @type {?} */
ShAttachMenuDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ShAttachMenuDirective.ctorParameters;
/** @type {?} */
ShAttachMenuDirective.propDecorators;
/** @type {?} */
ShAttachMenuDirective.prototype.menu;
/** @type {?} */
ShAttachMenuDirective.prototype.triggers;
/** @type {?} */
ShAttachMenuDirective.prototype.data;
/** @type {?} */
ShAttachMenuDirective.prototype.sub;
/** @type {?} */
ShAttachMenuDirective.prototype.ctxService;
/** @type {?} */
ShAttachMenuDirective.prototype.elm;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
